import React from "react";
import Logging from "./Logging";
import { SettlementEndGame } from "../Settlements/SettlementEndGame";

/**
 * SidebarContent — Pure presentational component for sidebar content.
 * Renders Hand History (Logging) and Settlement sections.
 * Extracted from Main.js (TD-FE-CLEANUP-001-S01).
 *
 * @param {Object} props
 * @param {boolean} [props.showHeadings=false] - Whether to show section headings
 * @param {string} [props.settlementClassName=""] - Additional className for settlement wrapper
 * @param {Object} props.gameState - The game state object
 * @param {boolean} props.settlementModalEndGameOpen - Whether the settlement modal is open
 * @param {Function} props.setSettlementModalEndGameOpen - Setter for settlement modal open state
 */
const SidebarContent = ({
  showHeadings = false,
  settlementClassName = "",
  gameState,
  settlementModalEndGameOpen,
  setSettlementModalEndGameOpen,
}) => (
  <>
    {showHeadings && <h6 className="text-light mb-3">Hand History</h6>}
    <Logging collapsed={false} />
    <div className={`mt-3 ${settlementClassName}`.trim()}>
      {showHeadings && <h6 className="text-light mb-2">Settlement</h6>}
      <SettlementEndGame
        isShow={false}
        gameState={gameState}
        open={setSettlementModalEndGameOpen ? settlementModalEndGameOpen : false}
        setOpen={setSettlementModalEndGameOpen}
      />
    </div>
  </>
);

export default SidebarContent;
